module.exports = __webpack_public_path__ + "static/media/wraps.a21a1bc0.jpg";